<mat-calendar-header>
  <button mat-raised-button color="primary" (click)="todayClicked()" style="color: white">TODAY</button>
</mat-calendar-header>
